import { observer } from 'mobx-react-lite'
import { CollapseWithIcon } from 'shared/ui'
import { type Integration } from 'entities/Integrations'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { IntegrationActiveCampaignSettingsStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationActiveCampaignSettings/store/IntegrationActiveCampaignSettingsStore'
import { useIntegrationStoreMemo } from 'pages/settings/pages/integrations/pages/integrationSettings/hooks/useIntegrationStoreMemo'
import { CollapseIntegrationSettingsUsers } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsUsers/CollapseIntegrationSettingsUsers'
import { CollapseIntegrationSettingsProperty } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsProperty/CollapseIntegrationSettingsProperty'
import { IntegrationActiveCampaignSettingsSync } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationActiveCampaignSettings/ui/IntegrationActiveCampaignSettingsSync/IntegrationActiveCampaignSettingsSync'
import { CollapseIntegrationSettingsTimeline } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsTimeline/CollapseIntegrationSettingsTimeline'
import { CollapseIntegrationSettingsWebhook } from 'pages/settings/pages/integrations/pages/integrationSettings/ui/CollapseIntegrationSettingsWebhook/CollapseIntegrationSettingsWebhook'
import sharedStyles from 'pages/settings/pages/integrations/pages/integrationSettings/ui/styles.module.scss'

type IIntegrationActiveCampaignSettingsProps = {
  integration: Integration
}

export const IntegrationActiveCampaignSettings = observer(
  ({ integration }: IIntegrationActiveCampaignSettingsProps) => {
    const entities = useEntitiesContext()
    const { collapseStore, userStore, syncStore, propertyStore, timelineStore, webhookStore } =
      useIntegrationStoreMemo(IntegrationActiveCampaignSettingsStore, integration, entities)

    return (
      <div>
        <CollapseIntegrationSettingsUsers collapseStore={collapseStore} userStore={userStore} />
        <CollapseWithIcon
          opened={collapseStore.opened('sync')}
          onClick={collapseStore.onToggle('sync')}
          icon={'arrowHorizontalOutline'}
          title={'Contact syncing'}
          label={syncStore.getLabel}
          headerClassName={sharedStyles.collapseWithIcon}
        >
          <IntegrationActiveCampaignSettingsSync store={syncStore} />
        </CollapseWithIcon>
        <CollapseIntegrationSettingsProperty
          collapseStore={collapseStore}
          propertyStore={propertyStore}
        />
        <CollapseIntegrationSettingsTimeline
          collapseStore={collapseStore}
          name={integration.name}
          dailyBundles={timelineStore.dailyBundles}
          onDailyBundlesToggle={timelineStore.onDailyBundlesToggle}
        />
        <CollapseIntegrationSettingsWebhook
          collapseStore={collapseStore}
          webhookStore={webhookStore}
        />
      </div>
    )
  }
)
